import React from 'react';
import { Button, Col, Form, Input, message, Row } from 'antd';
import DocumentTitle from 'react-document-title';
import { Link } from 'react-router-dom';
import { resetPassword } from '../services/AuthService';
import { FormInstance } from 'antd/es/form';
import { primaryColor } from '../config';
import FormLogo from './FormLogo';
import { LogoComponent } from '../images';

export default class PasswordResetForm extends React.Component<any, any> {
    private formRef = React.createRef<FormInstance>();

    onFinish = () => {
        const { current } = this.formRef;
        if (current) {
            current.validateFields().then((values) => {
                const { username } = values;
                resetPassword({ username })
                    .then((data) => {
                        message.success(
                            'If your username is correct you should receive a password reset email from us shortly. Follow instructions on the email',
                        );
                    })
                    .catch((e) => {
                        console.log({ e });
                        if (navigator.onLine) {
                            message.error('Failed to reset password. Server connection error');
                        } else {
                            message.error('Failed to reset password. Please check your internet connection');
                        }
                    });
            });
        }
    };
    onFinishFailed = () => false;

    render() {
        const { site } = this.props;
        return (
            <DocumentTitle title={`Forgot your password?: ${site.name}`}>
                <Row>
                    <Col
                        className={'signup'}
                        xs={24}
                        sm={16}
                        md={12}
                        lg={8}
                        style={{
                            boxShadow: '0px 10px 20px rgba(60,60,60,.1)',
                            padding: '20px',
                            marginTop: '40px',
                            backgroundColor: '#fff',
                        }}
                    >
                        <Form
                            requiredMark={'optional'}
                            initialValues={{ remember: true }}
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Row>
                                <Col span={24} style={{ textAlign: 'center' }}>
                                    <LogoComponent
                                        height="128px"
                                        width="128px"
                                        style={{
                                            textAlign: 'center',
                                            marginTop: '50px',
                                            marginBottom: '50px',
                                        }}
                                    />
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={
                                            <span
                                                style={{
                                                    fontSize: '1rem',
                                                    fontWeight: 600,
                                                    lineHeight: 1.5,
                                                    textAlign: 'left',
                                                }}
                                            >
                                                Username
                                            </span>
                                        }
                                        labelCol={{
                                            span: 24,
                                            style: {
                                                fontSize: '1rem',
                                                fontWeight: 600,
                                                lineHeight: 1.5,
                                                textAlign: 'left',
                                            },
                                        }}
                                        wrapperCol={{ span: 24 }}
                                        name="username"
                                        rules={[{ required: true, message: 'Please input your username!' }]}
                                    >
                                        <Input style={{ height: '52px', borderRadius: '0.5em' }} size={'large'} />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item>
                                        <Button
                                            block={true}
                                            size={'large'}
                                            style={{
                                                background: primaryColor,
                                                borderColor: primaryColor,
                                                height: '52px',
                                                fontWeight: 600,
                                                color: 'white',
                                                borderRadius: '0.5em',
                                            }}
                                            htmlType="submit"
                                        >
                                            Reset Password
                                        </Button>
                                    </Form.Item>
                                </Col>

                                <Col span={24} style={{ textAlign: 'center' }}>
                                    <label
                                        style={{
                                            fontWeight: 400,

                                            color: 'gray',
                                        }}
                                    >
                                        Already have an account?{' '}
                                        <Link to={'/login'} style={{ color: '#e96122' }}>
                                            {' '}
                                            Sign in
                                        </Link>
                                    </label>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </DocumentTitle>
        );
    }
}
